import React, { useState, useEffect } from "react";
import "./StaffLogin.css";
import axiosConfig from "../../Service/axiosConfig";
import { useNavigate, useLocation } from "react-router-dom";
import { MdOutlineEdit } from "react-icons/md";
import cmeazLogo from "../../assets/images/cmeaz_logo.png"

const StaffLogin = () => {
  let navigate = useNavigate();
  let location = useLocation();
  const [visible, SetVisable] = useState(false);
  const [LoadingButton, setLoadingButton] = useState(false);
  const inputType = visible ? "text" : "password";
  const [Data, SetData] = useState({
    mobileno: "",
    password: "",
    otp: "",
    new_password: "",
    confirm_password: "",
  });
  const [error, SetError] = useState("");
  const [LoginTitle, setLogintitle] = useState("Login your Account");
  const [Title, setTitle] = useState("Login");

  const InputHandleer = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    SetData({ ...Data, [name]: value });
  };

  useEffect(() => {
    const pathMapping = {
      "/": { loginTitle: "Login your Account", title: "Login" },
      "/send_otp": { loginTitle: "Forgot Password", title: "Send OTP" },
      "/verify-otp": { loginTitle: "Verify OTP", title: "Verify" },
      "/reset_password": { loginTitle: "Reset Password", title: "Save" },
      "/set_password": { loginTitle: "Set New Password", title: "Save" },
      "/login": { loginTitle: "Login your Account", title: "Login" },
    };

    const currentPath = pathMapping[location.pathname];

    if (currentPath) {
      setLogintitle(currentPath.loginTitle);
      setTitle(currentPath.title);
      SetError("");
    }
  }, [location]);

  const SubmitHandller = (e) => {
    e.preventDefault();
    SetError("");
    const { mobileno, password, otp, new_password, confirm_password } = Data;

    // Validation based on current route
    switch (location.pathname) {
      case "/login":
        if (!mobileno) {
          SetError("Email is required");
          return;
        }
        if (!password) {
          SetError("Password is required");
          return;
        }
        setLoadingButton(true);
        loginUser();
        break;

      case "/send_otp":
        if (!mobileno) {
          SetError("Email is required");
          return;
        }
        setLoadingButton(true);
        sendOTP();
        break;

      case "/verify-otp":
        if (!otp) {
          SetError("OTP is required");
          return;
        }
        setLoadingButton(true);
        verifyOTP();
        break;

      // case "/reset_password":
      // case "/set_password":
      //   if (!new_password) {
      //     SetError("New Password is required");
      //     return;
      //   }
      //   if (!confirm_password) {
      //     SetError("Confirm Password is required");
      //     return;
      //   }
      //   if (new_password !== confirm_password) {
      //     SetError("New password and confirm password do not match");
      //     return;
      //   }
      //   setLoadingButton(true);
      //   resetPassword();
      //   setPassword();
      //   break;
      case "/reset_password":
        if (!new_password) {
          SetError("New Password is required");
          return;
        }
        if (!confirm_password) {
          SetError("Confirm Password is required");
          return;
        }
        if (new_password !== confirm_password) {
          SetError("New password and confirm password do not match");
          return;
        }
        setLoadingButton(true);
        resetPassword(); // Call resetPassword for this path
        break;

      case "/set_password":
        if (!new_password) {
          SetError("New Password is required");
          return;
        }
        if (!confirm_password) {
          SetError("Confirm Password is required");
          return;
        }
        if (new_password !== confirm_password) {
          SetError("New password and confirm password do not match");
          return;
        }
        setLoadingButton(true);
        setPassword(); // Call setPassword only for this path
        break;

      default:
        break;
    }
  };

  const handleRedirect = (role) => {
    try {
      switch (role) {
        case "Admin":
          navigate("/");
          break;
        case "Trainer":
          navigate("/trainer");
          break;
        case "Student":
          navigate("/student");
          break;
        default:
          break;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const loginUser = () => {
    const formData = new FormData();
    formData.append("mobileno", Data.mobileno);
    formData.append("password", Data.password);

    axiosConfig
      .post("/accounts/api/login/", formData)
      .then((res) => {
        const { token, user } = res.data;
        localStorage.setItem("token", token);
        localStorage.setItem("user_data", JSON.stringify(user));
        navigate("/");

        if (user.set_newpassword) {
          navigate("/set_password");
        } else {
          handleRedirect(user.role);
        }
      })
      .catch((e) => {
        SetError(e.response?.data?.error || "An error occurred");
      })
      .finally(() => setLoadingButton(false));
  };

  const sendOTP = () => {
    axiosConfig
      .post("/accounts/api/reset_request/", { email: Data.mobileno })
      .then(() => {
        navigate("/verify-otp");
      })
      .catch((e) => {
        SetError(e.response?.data?.message || "An error occurred");
      })
      .finally(() => setLoadingButton(false));
  };

  const verifyOTP = () => {
    axiosConfig
      .post("/accounts/api/otp_verifivation/", {
        email: Data.mobileno,
        otp: Data.otp,
      })
      .then(() => {
        navigate("/reset_password");
      })
      .catch((e) => {
        SetError(e.response?.data?.message || "An error occurred");
      })
      .finally(() => setLoadingButton(false));
  };

  const resetPassword = () => {
    axiosConfig
      .post("/accounts/api/password_forgot/", {
        new_password: Data.new_password,
        confirm_password: Data.confirm_password,
        email: Data.mobileno,
        otp: Data.otp,
      })
      .then(() => {
        navigate("/");
      })
      .catch((e) => {
        SetError(e.response?.data?.message || "An error occurred");
      })
      .finally(() => setLoadingButton(false));
  };
  const setPassword = () => {
    axiosConfig
      .post(`/accounts/api/set_password/`, {
        new_password: Data.new_password,
        confirm_password: Data.confirm_password,
      })
      .then(() => {
        SetData({
          mobileno: "",
          password: "",
          otp: "",
          new_password: "",
          confirm_password: "",
        });
        navigate("/login");
      })
      .catch((e) => {
        SetError(e.response?.data?.message || "An error occurred");
      })
      .finally(() => {
        setLoadingButton(false);
      });
  };

  return (
    <div className="login-main">
      <div className="container">
        <div className="login-container">
          <div className="login-c-left">
            <div className="login-image text-center">
               
              <img
                className="vector1"
                src={cmeazLogo}
                alt="banner"
              />
            </div>
          </div>
          <div className="login-c-right">
            <div className="login-form">
              <div className="form-container">
                <h2>{LoginTitle}</h2>
                <div className="Loginerror">
                  <p>{error}</p>
                </div>
                <form>
                  {LoginTitle === "Login your Account" && (
                    <>
                      <div className="form-group">
                        <label>Email or Phone:</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Email Address or Phone Number"
                          name="mobileno"
                          value={Data.mobileno}
                          onChange={InputHandleer}
                        />
                      </div>

                      <div className="form-group has-icon">
                        <label>Password:</label>
                        <input
                          type={inputType}
                          className="form-control"
                          placeholder="Enter password"
                          name="password"
                          value={Data.password}
                          onChange={InputHandleer}
                        />
                        {visible ? (
                          <img
                            className="inputicon1"
                            src={require("../../Pages/images/show.png")}
                            alt="password"
                            onClick={() => SetVisable(false)}
                          />
                        ) : (
                          <img
                            className="inputicon"
                            src={require("./images/eye.jpg")}
                            alt="password"
                            onClick={() => SetVisable(true)}
                          />
                        )}
                      </div>
                    </>
                  )}

                  {LoginTitle === "Forgot Password" && (
                    <div className="form-group">
                      <label>Email:</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Email Address"
                        name="mobileno"
                        value={Data.mobileno}
                        onChange={InputHandleer}
                      />
                    </div>
                  )}

                  {LoginTitle === "Verify OTP" && (
                    <>
                      <div className="form-group position-relative">
                        <label>Email:</label>
                        <input
                          type="text"
                          className="form-control"
                          name="mobileno"
                          value={Data.mobileno}
                          onChange={InputHandleer}
                          disabled
                        />
                        <span
                          className="edit-icon"
                          onClick={() => navigate("/send_otp")}
                        >
                          <MdOutlineEdit />
                        </span>
                      </div>
                      <div className="form-group">
                        <label>OTP:</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter OTP"
                          name="otp"
                          value={Data.otp}
                          onChange={InputHandleer}
                        />
                      </div>
                    </>
                  )}

                  {(LoginTitle === "Reset Password" ||
                    LoginTitle === "Set New Password") && (
                    <>
                      <div className="form-group">
                        <label>New Password:</label>
                        <input
                          type={inputType}
                          className="form-control"
                          placeholder="Enter New Password"
                          name="new_password"
                          value={Data.new_password}
                          onChange={InputHandleer}
                        />
                      </div>
                      <div className="form-group has-icon">
                        <label>Confirm Password:</label>
                        <input
                          type={inputType}
                          className="form-control"
                          placeholder="Confirm New Password"
                          name="confirm_password"
                          value={Data.confirm_password}
                          onChange={InputHandleer}
                        />
                        {visible ? (
                          <img
                            className="inputicon1"
                            src={require("../../Pages/images/show.png")}
                            alt="password"
                            onClick={() => SetVisable(false)}
                          />
                        ) : (
                          <img
                            className="inputicon"
                            src={require("./images/eye.jpg")}
                            alt="password"
                            onClick={() => SetVisable(true)}
                          />
                        )}
                      </div>
                    </>
                  )}

                  <button
                    type="submit"
                    className="btn btn-primary"
                    onClick={SubmitHandller}
                    disabled={LoadingButton}
                  >
                    {LoadingButton ? "Processing..." : Title}
                  </button>
                  {LoginTitle === "Login your Account" && (
                    <a href="/send_otp">
                      <p>Forget password</p>
                    </a>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { StaffLogin };
